import { render } from "@/web/pages/habitaciones/Habitaciones.html?vue&type=template&id=5e14c6e3&ts=true"
import script from "@/web/ts/controllers/habitacion/habitaciones?vue&type=script&lang=ts"
export * from "@/web/ts/controllers/habitacion/habitaciones?vue&type=script&lang=ts"

import "@/web/css/custom.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/femers/git/adminSanatorio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__